import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { ConsumoFolha } from 'src/app/admihair/api/dto/consumo-folha';
import { FolhaPessoaFisica } from 'src/app/admihair/api/dto/folha-pessoa-fisica';
import { ConsumoFolhaService } from 'src/app/admihair/service/consumo-folha.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-consumo-detalhar',
  templateUrl: './consumo-detalhar.component.html',
  styleUrls: ['./consumo-detalhar.component.scss']
})
export class ConsumoDetalharComponent extends AdmihairBaseComponent implements OnInit {

  loading: boolean = true;
  id?: number;
  consumoFolha?: ConsumoFolha;
  parcelasConsumo: FolhaPessoaFisica[] = [];

  constructor(private consumoService: ConsumoFolhaService,
    private activatedRouter: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService
  ) {
    super(erroService, storageService)
  }

  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_CONSUMO');
    this.carregarId();
    if (this.permissaoDetalhar) {
      this.carregarConsumo();
    }
  }

  carregarId() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

  carregarConsumo() {
    this.consumoService.buscarPorId(this.id).subscribe({
      next: (data: ConsumoFolha) => {
        this.consumoFolha = data;
        if (data.listaFolha) {
          this.parcelasConsumo = data.listaFolha;
        }
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

}
